'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _CartDropdownItem = require('./CartDropdownItem');

var _CartDropdownItem2 = _interopRequireDefault(_CartDropdownItem);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _ReOrder = require('../order/ReOrder');

var _ReOrder2 = _interopRequireDefault(_ReOrder);

var _Heart = require('../generic/Heart');

var _Heart2 = _interopRequireDefault(_Heart);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderCard = function (_React$Component) {
	_inherits(OrderCard, _React$Component);

	function OrderCard() {
		_classCallCheck(this, OrderCard);

		return _possibleConstructorReturn(this, (OrderCard.__proto__ || Object.getPrototypeOf(OrderCard)).apply(this, arguments));
	}

	_createClass(OrderCard, [{
		key: 'getOrderItemsToPrepStr',


		// componentDidMount(){
		// 	console.log("order card: " + JSON.stringify(this.props.order))
		// }


		value: function getOrderItemsToPrepStr(order) {
			if (order.itemsToPrep) {
				return order.itemsToPrep + ' ' + (order.itemsToPrep > 1 ? 'items' : 'item');
			} else if (order.itemCount) {
				return order.itemCount + ' ' + (order.itemCount > 1 ? 'items' : 'item');
			} else {
				return "";
			}
		}
	}, {
		key: 'getDeliveryAddress',
		value: function getDeliveryAddress() {
			var order = this.props.order;
			var currentUser = _parse2.default.User.current();
			var address = "";

			if (order === null) {
				return "";
			}

			if (currentUser) {
				address = currentUser.get("name") + ', ' + order.deliveryAddLine1 + '\n            ' + order.deliveryAddLine2 + ', ' + order.deliveryCity + ', ' + order.deliveryState + ' ' + order.deliveryZip + '\n            ' + Utils.formatPhoneNumber(order.deliveryPhone);
			}

			return address;
		}
	}, {
		key: 'renderOrderRow',
		value: function renderOrderRow() {
			var self = this;
			return this.props.order.items.map(function (item, index, array) {

				return _react2.default.createElement(
					_react2.default.Fragment,
					{ key: item.itemObjectId + index },
					_react2.default.createElement(_CartDropdownItem2.default, {
						icoIcon: 'ui-press',
						iconClass: 'text-success food-item',
						title: item.itemName + ' x ' + item.itemQty,
						item: item,
						itemOptionCategories: item.itemOptionCategories
					})
				);
			});
		}
	}, {
		key: 'getCustomChargeStructureOfOptional',
		value: function getCustomChargeStructureOfOptional(order) {

			var customCharges = order.charge;
			if (customCharges != undefined && customCharges.length > 0) {

				return customCharges.map(function (charge, index, array) {

					var component = null;

					if (charge.type == "O" && !Utils.isEmpty(charge.optionName)) {
						component =
						// <div key={index} className=" optional-charge-view">
						// 	<strong>{charge.name}</strong> : {charge.optionName}
						// </div>
						_react2.default.createElement(
							'div',
							{ key: index },
							_react2.default.createElement(
								'p',
								{ className: 'pl-3 mb-0' },
								_react2.default.createElement(
									'b',
									null,
									charge.name
								),
								_react2.default.createElement(
									'span',
									{ className: 'pull-right' },
									' ',
									charge.optionName
								)
							),
							_react2.default.createElement('hr', { className: "mt-10 mb-10" })
						);
					}
					return component;
				});
			}
		}
	}, {
		key: 'getCouponStructure',
		value: function getCouponStructure(order) {
			var couponInfo = order.couponInfo;
			if (couponInfo && !Utils.isEmptyObj(couponInfo)) {
				var component = _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'p',
						{ className: 'pl-3 badge-success mb-0' },
						'Applied coupon ',
						_react2.default.createElement(
							'b',
							null,
							couponInfo.couponCode
						),
						' for this order.'
					),
					_react2.default.createElement('br', null),
					_react2.default.createElement('hr', { className: "mt-n2 mb-10" }),
					_react2.default.createElement(
						'p',
						{ className: "pl-3 mb-0" },
						'sub total ',
						_react2.default.createElement(
							'b',
							{ className: 'pull-right' },
							' $',
							Utils.toRoundStr(order.subTotal, 2)
						)
					),
					_react2.default.createElement(
						'p',
						{ className: 'pl-3 mb-0 badge-success' },
						'Discount ',
						_react2.default.createElement(
							'b',
							{ className: 'pull-right' },
							' -$',
							Number(couponInfo.discountAmount).toFixed(2)
						)
					),
					_react2.default.createElement(
						'p',
						{ className: 'pl-3 mb-0' },
						'Discounted sub total ',
						_react2.default.createElement(
							'b',
							{ className: 'pull-right' },
							' $',
							Number(order.subTotal - couponInfo.discountAmount).toFixed(2)
						)
					)
				);
				return component;
			} else {
				return _react2.default.createElement(
					'p',
					{ className: 'mb-0 text-secondary pl-3' },
					'Sub Total',
					_react2.default.createElement(
						'span',
						{ className: 'float-right' },
						'$',
						Utils.toRoundStr(order.subTotal, 2)
					)
				);
			}
		}
	}, {
		key: 'getDeliveryFeeStructure',
		value: function getDeliveryFeeStructure(order) {
			var component = null;

			if (order.deliveryFee) {
				component = _react2.default.createElement(
					'p',
					{ className: 'pl-3 mb-0 text-secondary' },
					'Delivery Fee',
					_react2.default.createElement(
						'span',
						{ className: 'float-right' },
						'$',
						Utils.toRoundStr(order.deliveryFee, 2)
					)
				);
			}

			return component;
		}
	}, {
		key: 'getServiceFeeStructure',
		value: function getServiceFeeStructure(order) {
			var component = null;

			if (order.serviceFee) {
				component = _react2.default.createElement(
					'p',
					{ className: 'pl-3 mb-0 text-secondary' },
					'Service Fee',
					_react2.default.createElement(
						'span',
						{ className: 'float-right' },
						'$',
						Utils.toRoundStr(order.serviceFee, 2)
					)
				);
			}

			return component;
		}
	}, {
		key: 'getDriverTipStructure',
		value: function getDriverTipStructure(order) {
			var component = null;
			if (order.tipAmount) {
				component = _react2.default.createElement(
					'p',
					{ className: 'pl-3 mb-0 text-secondary' },
					'Tip',
					_react2.default.createElement(
						'span',
						{ className: 'float-right' },
						'$',
						_lodash2.default.round(order.tipAmount || 0, 2).toFixed(2)
					)
				);
			}
			return component;
		}
	}, {
		key: 'getCustomChargeStructure',
		value: function getCustomChargeStructure(order) {

			var customCharges = order.charge;
			if (customCharges != undefined && customCharges.length > 0) {

				return customCharges.map(function (charge, index, array) {

					var descComponent = null;
					var chargeDescription = "";

					if (!Utils.isEmpty(charge.typeDetailsName)) {
						chargeDescription = charge.typeDetailsName;
					} else if (!Utils.isEmpty(charge.desc)) {
						chargeDescription = charge.desc;
					} else {
						chargeDescription = "";
					}

					if (!Utils.isEmpty(chargeDescription)) {
						descComponent = _react2.default.createElement(
							'span',
							null,
							_react2.default.createElement(
								'a',
								{ 'data-tip': chargeDescription, className: 'color-styl tooltip-button',
									style: { cursor: 'pointer' } },
								_react2.default.createElement('i', {
									className: 'fa fa-info-circle'
								})
							),
							_react2.default.createElement(_reactTooltip2.default, { place: 'right', wrapper: 'span' })
						);
					}

					return _react2.default.createElement(
						'p',
						{ className: "pl-3 mb-0 text-secondary", key: index },
						charge.name,
						' ',
						descComponent,
						_react2.default.createElement(
							'span',
							{ className: 'float-right' },
							'$',
							Utils.toRoundStr(charge.fee, 2)
						)
					);
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var self = this;
			var PaymentType = null;
			var order = this.props.order;
			var orderDetail = order.orderDetail;
			// console.log(order.scheduledAt.iso)
			var dispStr = "";
			var isDeliveryOrder = false;
			var isCurbsidePickupOrder = false;
			var isUtensilsAndNapkins = false;
			var utensilsAndNapkins = "No";
			var vMakeModel = null;
			var vColor = null;
			var orderIdx = this.props.index;

			var isDineInEnabled = false;
			var slData = null;

			var orderTypeStatus = order.orderType;

			if (orderTypeStatus == "Delivery") {
				dispStr = "DELIVER TO";
				isDeliveryOrder = true;
			}

			if (orderTypeStatus == "PickUp" && !Utils.isEmptyObj(order.curbsidePickup)) {

				// get the screen width and added condition
				var screenWidth = screen.width;
				if (screenWidth > 480) {
					orderTypeStatus = "Curbside Pickup";
				} else {
					orderTypeStatus = "Curbside";
				}

				dispStr = "VEHICLE DETAILS";
				isCurbsidePickupOrder = true;

				if (order.curbsidePickup && order.curbsidePickup.vMakeModel) {
					vMakeModel = order.curbsidePickup.vMakeModel;
				}

				if (order.curbsidePickup && order.curbsidePickup.vColor) {
					vColor = order.curbsidePickup.vColor;
				}
			}

			if (orderTypeStatus == "DineIn" && !Utils.isEmptyObj(order.dineIn)) {

				orderTypeStatus = "Dine In";

				isDineInEnabled = true;

				if (order.dineIn && order.dineIn.serviceLocation) {
					dispStr = order.dineIn.serviceLocation;
				} else {
					dispStr = "TABLE";
				}

				if (order.dineIn && order.dineIn.slData) {
					slData = order.dineIn.slData;
				} else if (order.dineIn && order.dineIn.tableNumber) {
					slData = order.dineIn.tableNumber;
				} else {
					slData = "Not Available";
				}
			}

			/*
         * Check the order extraInfo exist or not
         * */

			if (!Utils.isEmptyObj(order.extraInfo)) {

				var extraInfo = order.extraInfo;
				// check the utensilsAndNapkins key exist or not
				if (Utils.isVariableDefined(extraInfo.utensilsAndNapkins)) {
					isUtensilsAndNapkins = true;

					utensilsAndNapkins = extraInfo.utensilsAndNapkins ? "Yes" : "No";
				}
			}

			var itemsToPrepStr = this.getOrderItemsToPrepStr(order);

			if (order.chargeId == null) {
				PaymentType = "NO PAYMENT MADE!";
			} else {
				// PaymentType = order.paymentType ? order.paymentType : null;
				PaymentType = !Utils.isEmptyObj(order.paymentDetail) ? order.paymentDetail.paymentType : null;
			}

			return _react2.default.createElement(
				'div',
				{ className: 'bg-white card mb-4 order-list shadow-sm' },
				_react2.default.createElement(
					'div',
					{ className: 'gold-members p-4' },
					_react2.default.createElement(
						'div',
						{ className: "media" },
						_react2.default.createElement(
							'div',
							{ className: "media-body" },
							_react2.default.createElement(
								'div',
								{ className: 'osahan-track-order-detail po' },
								_react2.default.createElement(
									'h5',
									{ className: 'color-styl mt-0 mb-3' },
									_react2.default.createElement(
										'span',
										{ className: "text-black" },
										'ORDER'
									),
									' #',
									this.props.order.orderNum
								),
								_react2.default.createElement(
									'h6',
									{ className: 'text-dark mt-0 mb-3' },
									order.orderType,
									' Order Placed at ',
									_react2.default.createElement(_reactIcofont2.default, { icon: 'clock-time', className: 'ml-2' }),
									_react2.default.createElement(
										'span',
										{ className: "text-black" },
										' ',
										Utils.formatDateTimeWithTimeZone(new Date(order.createdAt), this.props.locationDetail.timeZone)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: "row" },
									_react2.default.createElement(
										'div',
										{ className: "col-md-6" },
										_react2.default.createElement(
											'small',
											{ className: 'ft-14 text-dark' },
											'PAYMENT'
										),
										_react2.default.createElement(
											'p',
											{ className: 'text-gray mb-5' },
											_react2.default.createElement(_reactIcofont2.default, { icon: 'food-cart' }),
											' ',
											PaymentType
										),
										isUtensilsAndNapkins ? _react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'small',
												{ className: 'ft-14 text-dark' },
												'UTENSILS & NAPKINS'
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-gray mb-5' },
												_react2.default.createElement(_reactIcofont2.default, { icon: 'food-cart' }),
												' ',
												utensilsAndNapkins
											)
										) : null,
										_react2.default.createElement(
											'small',
											{ className: 'ft-14 text-dark' },
											'RESTAURANT ADDRESS '
										),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'p',
												{ className: 'location-card-ico text-gray mb-5' },
												_react2.default.createElement(
													'i',
													{ className: 'icofont-location-pin  ' },
													' '
												)
											),
											_react2.default.createElement(
												'p',
												{ className: 'location-card-title text-gray mb-5' },
												this.props.resAddress
											)
										),
										!Utils.isEmptyObj(order.scheduledAt) ? _react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'small',
												{ className: 'ft-14 text-dark' },
												'SCHEDULED AT'
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-gray mb-5' },
												_react2.default.createElement(_reactIcofont2.default, { icon: 'clock-time' }),
												'    ',
												Utils.formatDateTimeWithTimeZone(new Date(order.scheduledAt.iso), this.props.locationDetail.timeZone)
											)
										) : null,
										isCurbsidePickupOrder ? _react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'small',
												{ className: 'ft-14 text-dark' },
												dispStr
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-gray mb-5' },
												_react2.default.createElement(_reactIcofont2.default, { icon: 'food-cart' }),
												' ',
												_react2.default.createElement(
													'span',
													{ className: 'bold' },
													' ',
													vColor,
													' ',
													vMakeModel
												)
											)
										) : null,
										isDineInEnabled ? _react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'small',
												{ className: 'ft-14 text-dark' },
												dispStr
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-gray mb-5' },
												_react2.default.createElement(_reactIcofont2.default, { icon: 'food-cart' }),
												' ',
												_react2.default.createElement(
													'span',
													{ className: 'bold' },
													' ',
													slData
												)
											)
										) : null,
										isDeliveryOrder ? _react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(
												'small',
												{ className: 'ft-14 text-dark' },
												dispStr
											),
											_react2.default.createElement(
												'div',
												null,
												_react2.default.createElement(
													'p',
													{ className: 'location-card-ico text-gray mb-5' },
													_react2.default.createElement(_reactIcofont2.default, { icon: 'map-pins' })
												),
												_react2.default.createElement(
													'p',
													{ className: 'location-card-title' },
													_react2.default.createElement(
														'span',
														{ className: 'bold ml-1' },
														self.getDeliveryAddress()
													)
												)
											)
										) : null,
										order.orderInstructions ? _react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(
												'small',
												{ className: 'ft-14 text-dark' },
												'Instructions:'
											),
											_react2.default.createElement(
												'p',
												{ className: 'text-gray mb-5' },
												_react2.default.createElement(_reactIcofont2.default, { icon: 'food-cart' }),
												' ',
												_react2.default.createElement(
													'span',
													{ className: 'bold' },
													' ',
													order.orderInstructions
												)
											)
										) : null
									),
									_react2.default.createElement(
										'div',
										{ className: "col-md-6" },
										this.renderOrderRow(),
										_react2.default.createElement('hr', { className: "mt-10 mb-10" }),
										this.getCustomChargeStructureOfOptional(order),
										this.getCouponStructure(order),
										this.getDeliveryFeeStructure(order),
										_react2.default.createElement(
											'p',
											{ className: 'pl-3 mb-0 text-secondary' },
											'Tax',
											_react2.default.createElement(
												'span',
												{ className: 'float-right' },
												'$',
												Utils.toRoundStr(order.taxes, 2)
											)
										),
										this.getServiceFeeStructure(order),
										this.getDriverTipStructure(order),
										this.getCustomChargeStructure(order),
										_react2.default.createElement('hr', { className: "mt-10 mb-10" }),
										_react2.default.createElement(
											'p',
											{ className: 'pl-3 mb-0 font-weight-bold text-black' },
											'TOTAL PAID  ',
											_react2.default.createElement(
												'span',
												{ className: 'float-right text-primary' },
												'$',
												Utils.toRoundStr(order.totalAmount, 2)
											)
										),
										_react2.default.createElement('hr', { className: "mt-10 mb-10" })
									),
									_react2.default.createElement(
										'div',
										{ className: "col-md-12 order-container-box" },
										order.orderStateChanges ? order.orderStateChanges.map(function (osChanges, idx) {

											var activeState = " li-padding ";
											if (osChanges.orderState == order.orderState) {
												activeState += "activeState";
											}

											return _react2.default.createElement(
												'span',
												{ key: '' + order.objectId + idx },
												_react2.default.createElement(
													'small',
													{ className: 'ft-12 font-weight-bold text-primary' },
													osChanges.orderState
												),
												_react2.default.createElement(
													'p',
													{ className: 'text-gray mb-0 text-primary' },
													_react2.default.createElement(
														'span',
														{ className: '' },
														Utils.formatDateTimeWithTimeZone(new Date(osChanges.timestamp), _this2.props.locationDetail.timeZone),
														', ',
														osChanges.stateChangedNote
													)
												)
											);
										}) : null
									)
								)
							),
							order.orderStateChanges || $(window).width() > 768 ? _react2.default.createElement('hr', null) : null,
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: "col-md-12 order-container-box" },
									_react2.default.createElement(
										'div',
										{ className: 'pull-left' },
										_react2.default.createElement(
											'p',
											{ className: 'mb-0 text-black text-primary' },
											_react2.default.createElement(
												'span',
												{ className: 'd-block font-weight-bold ft-16 text-black mb-0' },
												order.orderState
											),
											_react2.default.createElement(
												'small',
												{ className: 'color-styl mb-0' },
												'ORDER STATUS'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: "pull-right" },
										_react2.default.createElement(_Heart2.default, {
											isFavorite: order.isFavorite,
											orderId: order.objectId,
											classNames: "",
											locId: this.props.locId,
											history: this.props.history,
											idx: orderIdx
										}),
										_react2.default.createElement(_ReOrder2.default, {
											order: order,
											classNames: "pull-right",
											locationDetail: this.props.locationDetail,
											locId: this.props.locId,
											history: this.props.history,
											idx: orderIdx
										})
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return OrderCard;
}(_react2.default.Component);

exports.default = OrderCard;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/OrderCard.jsx
// module id = 551
// module chunks = 0